import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class AccessRightService {
  baseUrl = 'access-right';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getList = () => BaseService.get({ url: `${this.baseUrl}/get-list` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}/save`, data: user });
}

export default new AccessRightService()
